import { useState } from "react";
import {
  faBuildingColumns,
  faHouse,
  faPiggyBank,
  faUserGroup,
  faUsers,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BrowserRouter,
  Link,
  NavLink,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import BankszamlaPage from "./pages/BankszamlaPage";
import BabavaroPage from "./pages/BabavaroPage";
import LakashitelPage from "./pages/LakashitelPage";
import NyugdijbiztositasPage from "./pages/NyugdijbiztositasPage";
import SzemelyiKolcsonPage from "./pages/SzemelyiKolcsonPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Impresszum from "./pages/Impresszum";
import Rolunk from "./pages/Rolunk";
import partnerBankokMobil from "./assets/partner-bankok-mobil.png";

const PRODUCTS = [
  // {
  //   slug: "lakashitel",
  //   icon: faHouse,
  //   name: "Lakáshitel",
  //   subtitle:
  //     "Segítünk megtalálni a legkedvezőbb lakáshitelt, és a teljes ügyintézésben segítünk",
  // },
  {
    slug: "szemelyi-kolcson",
    icon: faWallet,
    name: "Személyi kölcsön",
    subtitle: "Gyors finanszírozás szabad felhasználásra akár 24 órán belül",
  },
  {
    slug: "bankszamla",
    icon: faBuildingColumns,
    name: "Bankszámla",
    subtitle:
      "Válassz költséghatékony számlacsomagot, és spórolj akár évi 60 ezer Ft-ot",
  },
  // {
  //   slug: "babavaro-hitel",
  //   icon: faUserGroup,
  //   name: "Babaváró hitel",
  //   subtitle: "Igényelj babaváró hitelt online, akár 2 munkanapon belül",
  // },
  // {
  //   slug: "nyugdijbiztositas",
  //   icon: faPiggyBank,
  //   name: "Nyugdíjbiztosítás",
  //   subtitle:
  //     "Építs stabil pénzügyi jövőt nyugdíjaskorra, akár napi 1 kávé áráért",
  // },
  {
    slug: "rolunk",
    icon: faUsers,
    name: "Rólunk",
    subtitle: "Tudj meg rólunk többet.",
  },
];

function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="shell header-inner">
        <Link className="brand" to="/">
          SzemélyiKölcsön.com
        </Link>
        <button
          type="button"
          className={`menu-toggle ${isMenuOpen ? "open" : ""}`}
          aria-label="Navigáció megnyitása"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <nav
          className={`top-nav ${isMenuOpen ? "open" : ""}`}
          aria-label="Fő navigáció"
        >
          {PRODUCTS.map((product) => (
            <NavLink
              key={product.slug}
              to={`/${product.slug}`}
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              {product.name}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

function HomePage() {
  const navigate = useNavigate();
  return (
    <main>
      <section className="hero-section">
        <div className="shell">
          <p className="hero-kicker">
            Bankfüggetlen, díjmentes összehasonlítás
          </p>
          <h1>Találd meg a hozzád illő pénzügyi megoldást</h1>
          <div className="tile-grid mt-2">
            {PRODUCTS.filter((product) => product.slug !== "rolunk")
              .slice(0, 2)
              .map((product) => (
                <article
                  key={product.slug}
                  className="tile-card"
                  onClick={() => navigate(`/${product.slug}`)}
                >
                  <h3>
                    <FontAwesomeIcon icon={product.icon} className="tile-icon" />
                    {product.name}
                  </h3>
                  <p className="mt-2">{product.subtitle}</p>
                </article>
              ))}
          </div>
        </div>
      </section>

      <section className="tile-section">
        <div className="shell">
          <h2>Kiemelt termékek</h2>
          <p className="section-lead">
            Válassz terméket, és nézd meg az összehasonlítást, feltételeket,
            valamint az azonnal használható kalkulátort.
          </p>
          <h2>Pénzügyi partnereink</h2>
          <div className="partner-image-wrap">
            <img
              src={partnerBankokMobil}
              alt="Banki partnereink"
              className="partner-image"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div>
          <h4>SzemélyiKölcsön.com</h4>
          <p>
            Független pénzügyi összehasonlítás és tájékoztatás hitel, bankszámla
            és megtakarítás területén.
          </p>
        </div>
        <div>
          <h4>Termékek</h4>
          <ul className="ms-2">
            {PRODUCTS.filter((product) => product.slug !== "rolunk").map(
              (product) => (
                <li key={product.slug}>
                  <Link to={`/${product.slug}`}>{product.name}</Link>
                </li>
              ),
            )}
          </ul>
        </div>
        <div>
          <h4>Kapcsolat</h4>
          <ul className="ms-2">
            <li className="footer-location">Budapest</li>
            <li>
              <a
                className="footer-contact-link"
                href="mailto:info@szemelyikolcson.com"
              >
                info@szemelyikolcson.com
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4>Jogi nyilatkozatok</h4>
          <ul className="ms-2">
            <li>
              <Link to="/adatkezelesi-tajekoztato">
                Adatkezelési tájékoztató
              </Link>
            </li>
            <li>
              <Link to="/impresszum">Impresszum</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lakashitel" element={<LakashitelPage />} />
        <Route path="/szemelyi-kolcson" element={<SzemelyiKolcsonPage />} />
        <Route path="/babavaro-hitel" element={<BabavaroPage />} />
        <Route path="/bankszamla" element={<BankszamlaPage />} />
        <Route path="/nyugdijbiztositas" element={<NyugdijbiztositasPage />} />
        <Route path="/rolunk" element={<Rolunk />} />
        <Route path="/adatkezelesi-tajekoztato" element={<PrivacyPolicy />} />
        <Route path="/impresszum" element={<Impresszum />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}
